<template>
  <div class="wallet-takt">
    <slot name="dialog" />
    <div>
      <slot name="header"/>
    </div>
    <div
      class="wallet-takt-body-slot"
      :id="'wallet_body_slot' + takt_index"
      :style="selected ? 'top: calc(100% - 68px); overflow: hidden;' : '' + ($store.state.View.is_printing_mode ? '' : 'overflow: auto;')"
      >      
      <!-- :style="selected?'overflow: hidden; padding-top: calc(100vh - 200px)':''" -->
      <slot name="body"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['selected', 'takt_index']
  }
</script>
<style>
.wallet-takt {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 3px;
  overflow: hidden;
  /* will-change: transform; */
}
.wallet-takt-body-slot {
  position: relative;
  height: calc(100% - 30px);
  padding-top: 3px;
  transition: all 0.2s ease-in-out;
  top: 0px;
}

</style>
